import { __assign, __rest } from 'tslib';
import React__default from 'react';
import { Box, Backdrop } from '@mui/material';
import clsx from 'clsx';
import { Upload } from '../Upload/index.js';
import StyledKModalImport, { classes } from './index.styled.js';
import { KModalImportMode } from './types.js';

var KModalImportBackdrop = function (_a) {
    var rest = __rest(_a, []);
    return (React__default.createElement(Backdrop, __assign({ sx: {
            zIndex: "-1",
            background: "rgba(0,0,0,0.9)",
            backdropFilter: "grayscale(1)"
        } }, rest, { invisible: true })));
};
var KModalImport = function (_a) {
    var _b = _a.testId, testId = _b === void 0 ? "KModalImport" : _b, id = _a.id, className = _a.className, sx = _a.sx, open = _a.open, uploadKey = _a.uploadKey, kgrid = _a.kgrid, children = _a.children, header = _a.header, mode = _a.mode;
    return (React__default.createElement(StyledKModalImport, { keepMounted: true, mode: mode, className: clsx("KModalImport", className), open: open, BackdropComponent: KModalImportBackdrop, "data-testid": testId, id: id, sx: __assign({ color: function (theme) { return theme.palette.common.white; } }, sx) },
        React__default.createElement(Upload, { uploadKey: uploadKey, enable: mode === KModalImportMode.Upload || mode === KModalImportMode.Indexing },
            React__default.createElement(Box, { sx: {
                    width: 1,
                    height: 1,
                    padding: function (theme) { return theme.spacing(5); }
                } },
                React__default.createElement(Box, { className: classes.content, sx: {
                        border: mode === KModalImportMode.Upload ? "3px dashed white" : "3px solid white",
                        width: 1,
                        height: 1,
                        borderRadius: function (theme) { return theme.shape.borderRadius; },
                        overflow: "hidden",
                        display: "grid",
                        gridTemplateAreas: "\n                \"kgrid actions actions\" \n                \"kgrid content content\"\n              ",
                        gridTemplateRows: "min-content 1fr",
                        gridTemplateColumns: "2fr 1fr 1fr"
                    } },
                    React__default.createElement(Box, { sx: { gridArea: "actions" } }, header),
                    React__default.createElement(Box, { sx: { gridArea: "kgrid" } }, kgrid),
                    React__default.createElement(Box, { sx: { gridArea: "content" } }, children))))));
};

export { KModalImport as default };
//# sourceMappingURL=index.js.map
